
import { defineComponent, ref, onMounted } from "vue"
import { Actions } from "@/store/enums/StoreEnums"
import { useStore } from "vuex"
import { useRoute, useRouter } from "vue-router"
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb"
import { ElMessage } from "element-plus"
import type { ElForm } from "element-plus"

type FormInstance = InstanceType<typeof ElForm>;

interface CardRarityForm {
  name: string;
  sort: number;
}

export default defineComponent({
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const formRef = ref<FormInstance>()

    const isNew = !route.params.id

    onMounted(() => {
      if (isNew) {
        setCurrentPageBreadcrumbs("新建稀有度", ["抽卡系统", "稀有度管理;card_rarities"])
      } else {
        setCurrentPageBreadcrumbs("编辑稀有度", ["抽卡系统", "稀有度管理;card_rarities"])
      }
    })

    const cardRarity = ref<CardRarityForm>({
      name: '',
      sort: 0
    })

    const rules = ref({
      name: [
        { required: true, message: '请输入稀有度名称', trigger: 'blur' },
        { min: 1, max: 20, message: '名称长度需在 1-20 之间', trigger: 'blur' }
      ]
    })

    // 加载详情（编辑模式）
    if (!isNew) {
      store
        .dispatch(Actions.GET_CARD_RARITY, route.params.id)
        .then(() => {
          const data = store.getters.currentCardRarity
          cardRarity.value = {
            name: data.name,
            sort: data.sort || 0
          }
        })
        .catch(() => {
          ElMessage.error('获取稀有度详情失败')
        })
    }

    const onSubmit = (formEl: FormInstance | undefined) => {
      if (!formEl) return

      formEl.validate((valid) => {
        if (valid) {
          const params = { ...cardRarity.value }

          if (isNew) {
            store
              .dispatch(Actions.CREATE_CARD_RARITY, params)
              .then((data: { success: boolean; error_msg?: string }) => {
                if (data.success) {
                  ElMessage.success('创建成功')
                  router.push({ name: 'card_rarities' })
                } else {
                  ElMessage.error(data.error_msg || '创建失败')
                }
              })
              .catch(() => {
                ElMessage.error('创建失败')
              })
          } else {
            store
              .dispatch(Actions.UPDATE_CARD_RARITY, {
                id: route.params.id,
                values: params
              })
              .then((data: { success: boolean; error_msg?: string }) => {
                if (data.success) {
                  ElMessage.success('更新成功')
                  router.push({ name: 'card_rarities' })
                } else {
                  ElMessage.error(data.error_msg || '更新失败')
                }
              })
              .catch(() => {
                ElMessage.error('更新失败')
              })
          }
        }
      })
    }

    const onCancel = () => {
      router.push({ name: 'card_rarities' })
    }

    return {
      formRef,
      cardRarity,
      rules,
      isNew,
      onSubmit,
      onCancel
    }
  }
})
